import React from "react";
import cn from "classnames";
import styles from "./data-acquisistion-type-and-icon.module.scss";

const cssClassName = "data-acquisistion-type-and-icon";

interface DataAcquisitionTypeWrapperPropTypes {
  typeOfDataBit: "POLLING" | "MONITORING";
}

export const DataAcquisitionTypeAndIcon = ({ typeOfDataBit }: DataAcquisitionTypeWrapperPropTypes) => {

  const capitalizeString = (text: string): string => {
    return `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`;
  }

  return (
    <span className={cn(styles[cssClassName],
      styles[`${cssClassName}--${typeOfDataBit.toLowerCase()}`]
    )}>
      {capitalizeString(typeOfDataBit)}
    </span>
  )
}
